import { getApplicationResourceManager } from '@neos/app'
import { createEnumType } from '@neos/core'

/**
 * Specifies the PrintJobResultCode.
 */
export enum PrintJobResultCode {
  /** Printer not found */
  printerNotFound = 'PrinterNotFound',
  /** Print succeeded */
  printSucceeded = 'PrintSucceeded',
  /** Print failed */
  printFailed = 'PrintFailed'
}

export const printJobResultCodeEnumType = createEnumType('PrintJobResultCode', {
  printerNotFound: { name: 'PrinterNotFound', get caption() { return getApplicationResourceManager('siga-webspace').find('enums.PrintJobResultCode.PrinterNotFound') ?? this.name }, getEnabled() { return true } },
  printSucceeded: { name: 'PrintSucceeded', get caption() { return getApplicationResourceManager('siga-webspace').find('enums.PrintJobResultCode.PrintSucceeded') ?? this.name }, getEnabled() { return true } },
  printFailed: { name: 'PrintFailed', get caption() { return getApplicationResourceManager('siga-webspace').find('enums.PrintJobResultCode.PrintFailed') ?? this.name }, getEnabled() { return true } },
})
